<template>
  <div class="container">
    <h1 class="page-header">Dashboard</h1>
    <div class="row" v-cloak>
      <div class="col-md-12 col-lg-7 mb-9">
        <div class="card">
          <h4 class="card-header">Recent quotes</h4>
          <div class="list-group list-group-flush">
            <router-link
              :to="'/quote/' + q.id"
              class="list-group-item list-group-item-action"
              v-for="q in quotes"
              :key="q.id"
            >
              {{ q.ref }} {{ q.name }} {{ q.postcode }}
              <span
                v-if="q.name != q.site_name || q.postcode != q.site_postcode"
              >/ {{ q.site_name }} {{ q.site_postcode}}</span>
              <span
                class="badge badge-pill float-right"
                :class="'system' + q.system_id"
              >{{ q.system_name }}</span>
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-lg-5 mb-4">
        <div class="card">
          <h4 class="card-header">Statistics</h4>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="(v, k) in stats" :key="k">
              {{ k | humanize }}
              <span
                class="badge badge-pill badge-info float-right"
              >{{ v | number }}</span>
            </li>
          </ul>
        </div>
      </div>

      <!-- <div class="col-md-12 col-lg-4 mb-4">
        <div class="card">
          <h4 class="card-header">Development to do</h4>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="t in todos" :key="t.id">{{ t.name }}</li>
          </ul>
          <div class="card-footer text-right">
            <router-link to="/dev_todo">View full list</router-link>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth";

export default {
  data() {
    return {
      stats: null,
      quotes: null,
      todos: null,
    };
  },
  filters: {
    humanize(s) {
      s = s.charAt(0).toUpperCase() + s.slice(1);
      return s.replace("_", " ");
    },
  },
  mounted() {
    authFetch("/db/dashboard_view").then((resp) =>
      resp.json().then((data) => {
        this.stats = data[0];
      })
    );
    authFetch("/db/quote_view?sort=id desc&limit=8").then((resp) =>
      resp.json().then((data) => {
        this.quotes = data;
      })
    );
    authFetch("/db/dev_todo?sort=id desc&limit=7").then((resp) =>
      resp.json().then((data) => {
        this.todos = data;
      })
    );
    // authFetch("/db/quotes_monthly_view").then((resp) =>
    //   resp.json().then((data) => {
    //     this.quotes = data;
    //   })
    // );
  },
};
</script>